// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__2vVZO","header":"Tabs_header__DtCwJ","links":"Tabs_links__kHp7E","body":"Tabs_body__12OEw"};